export const GET_ALL_BUSINESS = 'get_all_users';
export const GET_ALL_BUSINESS_SUCCESS = 'get_all_business_success';
export const DELETE_USER1 = 'delete_user1';
export const ADD_GUEST_USER = 'add_guest_user';
export const CHANGE_USER_STATUS = 'change_user_status';
export const ADD_RESTRICTED_USER = 'add_restricted_user';
